import template from './apiaccesslog.html';
import controller from './apiaccesslog.controller';
import './apiaccesslog.scss';

let apiaccesslogComponent = {
  bindings: {},
  template,
  controller
};

export default apiaccesslogComponent;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog.component.js